import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyStart: {
        id: 'policycommon.component.policy-common-details.Policy Start',
        defaultMessage: 'Effective Date'
    },
    PolicyExpiration: {
        id: 'policycommon.component.policy-common-details.Policy Expiration',
        defaultMessage: 'Expiry Date'
    },
    PolicyType: {
        id: 'policycommon.component.policy-common-details.Policy Type',
        defaultMessage: 'Policy Type'
    },
    TotalPremium: {
        id: 'policycommon.component.policy-common-details.Total Annual Premium',
        defaultMessage: 'Total Annual Premium'
    },
    TaxesAndFees: {
        id: 'policycommon.component.policy-common-details.Taxes and Fees',
        defaultMessage: 'Taxes and Fees'
    },
    TotalCost: {
        id: 'policycommon.component.policy-common-details.Total Annual Cost',
        defaultMessage: 'Total Annual Cost'
    },
    commonDetailsSection: {
        id: 'policycommon.component.policy-common-details.Details',
        defaultMessage: 'Details for {polNumber}'
    },
    premium: {
        id: 'policycommon.component.policy-common-details.Premium',
        defaultMessage: 'Premium'
    },
    policyStatus: {
        id: 'policycommon.component.policy-common-details.PolicyStatus',
        defaultMessage: 'Status'
    },
    active: {
        id: 'policycommon.component.policy-common-details.Active',
        defaultMessage: 'Active'
    },
    payments: {
        id: 'policycommon.component.policy-common-details.Payments',
        defaultMessage: 'Payments'
    },
    nextPaymentDueBy: {
        id: 'policycommon.component.policy-common-details.Next Payment Date',
        defaultMessage: 'Next Payment Date'
    },
    nextPaymentAmount: {
        id: 'policycommon.component.policy-common-details.Amount Due',
        defaultMessage: 'Amount Due'
    },
    lastPaymentDate: {
        id: 'policycommon.component.policy-common-details.Last Payment Date',
        defaultMessage: 'Last Payment Date'
    },
    lastPaymentAmount: {
        id: 'policycommon.component.policy-common-details.Amount Paid',
        defaultMessage: 'Amount Paid'
    },
});
